import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=3a672f06&scoped=true&"
import script from "./ExportButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./ExportButton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=3a672f06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a672f06",
  null
  
)

export default component.exports